import * as Yup from 'yup'
import cx from 'classnames'
import { Field } from '..'
import {
  GetStringFunction,
  DefaultStrings,
  getAddressStringSchema
} from '../../strings'
import { Country } from '../../countries'

export const AU: (
  getString: GetStringFunction<DefaultStrings>,
  required: boolean,
  countryOptions?: Country[]
) => Field[] = (getString, required, countryOptions) => {
  const zipCodeSchema = Yup.string().matches(/^\d{4}$/, {
    message: getString('error.match.postal_code'),
    excludeEmptyString: true
  })

  const showCountryDropdown = countryOptions && countryOptions.length > 0

  const fields: Field[] = [
    {
      label: getString('label.address2'),
      name: 'address2',
      type: 'text',
      containerClassName: 'w-full'
    },
    {
      label: getString('label.city'),
      name: 'city',
      type: 'text',
      containerClassName: cx('w-full', {
        'lg:w-1/2 lg:pl-4': showCountryDropdown
      }),
      validation: getAddressStringSchema(
        required,
        getString,
        'error.required.city'
      )
    },
    {
      label: getString('label.state'),
      name: 'stateName',
      type: 'text',
      containerClassName: 'w-full lg:w-1/2',
      validation: Yup.string().optional()
    },
    {
      label: getString('label.postal_code'),
      name: 'zipCode',
      type: 'text',
      containerClassName: 'w-full lg:w-1/2 lg:pl-4',
      validation: required
        ? zipCodeSchema.required(getString('error.required.postal_code'))
        : zipCodeSchema
    }
  ]

  if (showCountryDropdown) {
    fields.splice(1, 0, {
      label: getString('label.country'),
      name: 'country',
      type: 'select',
      options: countryOptions,
      containerClassName: 'w-full lg:w-1/2'
    })
  }

  return fields
}
